import pagination from "../static/pagination";

const mutations = {
  setLoadMore: (state, payload) => {
    state.isLoadMore = payload;
  },
  setFilter: (state, payload) => {
    state.isFilter = payload;
  },
  setResponse: (state, payload) => {
    state.response = payload;
  },

  setDetailOwner: (state, payload) => {
    state.detailOwner = payload;
  },

  setDataJenisTraining: (state, payload) => {
    state.dataJenisTraining = payload;
  },
  setDetailTraining: (state, payload) => {
    state.detailTraining = payload;
  },

  setDataUlasan: (state, payload) => {
    state.dataUlasan = payload;
  },

  //data list riwayat
  setDataListTraining: (state, payload) => {
    state.dataListTraining = state.dataListTraining.concat(payload);
  },

  setCountListTraining: (state, payload) => {
    state.countListTraining += payload;
  },

  resetDataList: (state) => {
    state.dataListTraining = [];
  },

  resetPagination: (state) => {
    state.pagination = pagination();
  },

  setNextPagination: (state, payload) => {
    state.pagination.length += payload.length;
    state.pagination.pageNumber++;
    state.pagination.offset =
      state.pagination.pageNumber * state.pagination.limit;
  },

  setLastItemToView: (state, payload) => {
    state.lastItemToView = payload;
  },

  setDataJadwalExist: (state, payload) => {
    state.dataTimeExist = payload;
  },

  setDataRescedule: (state, payload) => {
    state.dataResceduleAfterPost = payload;
  },

  setDataDetailPembayaran: (state, payload) => {
    state.dataDetailPembayaran = payload;
  },

  setDataJadwalUnavailable: (state, payload) => {
    state.dataJadwalUnavailable = payload;
  },

  resetDataJadwalUnavailable: (state) => {
    state.dataJadwalUnavailable = [];
  },

  setDetailJenisTraining: (state, payload) => {
    state.detailJenisTraining = payload;
  },
  setTrainingCreate: (state, payload) => {
    state.trainingCreate = payload;
  },

  setListJenisExist: (state, payload) => {
    state.listJenisExist = payload;
  },

  setRiwayatTraining: (state, payload) => {
    state.riwayatTraining = payload;
  },

  setListKeuangan: (state, payload) => {
    state.listAkunKeuangan = payload;
  },

  setDetailBayar: (state, payload) => {
    state.detailBayar = payload;
  },
  setJadwalUnavailable: (state, payload) => {
    state.jadwalUnavailable = payload;
  },
  setInformasiTagihan: (state, payload) => {
    state.infoTagihan = payload;
  },

  resetList: (state, { target }) => {
    state[`${target}List`] = [];
    state[`${target}Total`] = 0;

    if (target === "transaksi") {
      state.selectedTransaksi = [];
    }
  },
  setPromo: (state, payload) => {
    state.promo = payload;
  },
  resetPage: (state, { target }) => {
    state[`${target}Page`] = pagination();
  },

  resetFormJadwalTraining1(state) {
    state.formJadwal = {
      id_jenis_training: "",
      jadwal_training: [
        { jadwal_mulai: "", jadwal_selesai: "", sesi: 0 },
        { jadwal_mulai: "", jadwal_selesai: "", sesi: 0 },
      ],
      nama_owner: "",
      no_telp: "",
      pembayaran: {
        kode_promo: "",
        akun: "",
        metode_pembayaran: 0,
        kode_unik: 0,
      },
    };
  },
};

export default mutations;
